import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const Credit: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 46 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M43.1155 24.0604C37.9155 32.0604 18.2822 30.3937 9.11549 28.5604C1.61549 26.3937 -8.28451 19.2604 12.1155 8.0604C32.5155 -3.1396 39.9488 -0.272938 41.1155 2.5604C43.9488 6.39373 48.3155 16.0604 43.1155 24.0604Z"
        fill="#0BA95E"
        fillOpacity="0.2"
      />
      <path
        d="M12.5415 4.07641L17.9836 9.51847C19.2189 8.53029 20.7192 7.88806 22.3716 7.70213V0C18.6084 0.220496 15.1916 1.71901 12.5415 4.07641Z"
        fill="#1B3029"
      />
      <path
        d="M11.1887 5.42957C8.63183 8.30374 7 12.0758 7 16.2164C7 16.7452 7.42792 17.1731 7.95675 17.1731H13.761C14.2899 17.1731 14.7178 16.7452 14.7178 16.2164C14.7178 14.1872 15.4524 12.3448 16.6308 10.8716L11.1887 5.42957Z"
        fill="#1B3029"
      />
      <path
        d="M30.7208 8.73552C30.3985 8.45431 29.9313 8.41789 29.5753 8.64865L21.272 13.9452C20.163 14.6534 19.5015 15.8596 19.5015 17.1733C19.5015 19.2839 21.2178 21.0002 23.3285 21.0002C24.8122 21.0002 26.1744 20.1313 26.7985 18.7868L30.9572 9.85854C31.1366 9.47362 31.0404 9.01578 30.7208 8.73552Z"
        fill="#1B3029"
      />
      <path
        d="M35.4681 5.42957L32.656 8.24161C33.0101 8.9975 33.0567 9.88236 32.6912 10.6665L31.4331 13.3674C31.757 14.2571 31.939 15.2134 31.939 16.2164C31.939 16.7452 32.367 17.1731 32.8958 17.1731H38.7001C39.2289 17.1731 39.6568 16.7452 39.6568 16.2164C39.6568 12.0758 38.025 8.30374 35.4681 5.42957Z"
        fill="#1B3029"
      />
      <path
        d="M24.2852 0V7.70213C25.0907 7.79277 25.8582 7.99553 26.5784 8.29014L28.5466 7.03452C29.3352 6.52349 30.2988 6.41385 31.3024 6.88929L34.1153 4.07641C31.4652 1.71901 28.0484 0.220496 24.2852 0Z"
        fill="#1B3029"
      />
    </svg>
  )
})

Credit.displayName = 'Credit'
